'use strict';

import React, { useState, useEffect } from "react";
import { useCart, useCartDispatch } from "../../../../common/CartContext";
import { publish } from "../../../../common/EventDispatcher";
import { prepareCheckout } from "../../../../common/CartHelpers";

function ButtonBuyNow({ nsProductId, nid, icon, name, unitPrice }) {
  const [inCart, setInCart] = useState(false);
  const dispatch = useCartDispatch();
  const cartContents = useCart();

  useEffect(() => {
    const cartItem = cartContents.find((item) => item.nid === nid);
    if (cartItem) {
      setInCart(true);
    } else {
      setInCart(false);
    }
  }, [cartContents]);

  function handleBuyNow() {
    dispatch({
      type: "ADD_TO_CART",
      nsProductId: nsProductId,
      nid: nid,
      icon: icon,
      name: name,
      unitPrice: unitPrice,
      quantity: 1
    });
    publish("prepareCheckout");
    setTimeout(() => {
      prepareCheckout();
    }, 250);
  }

  return (

    <div className="d-flex buy-button" data-cart-status={inCart}>
      {!inCart && (
        <button className="secondary-button" onClick={handleBuyNow} type="button">
          Buy Now
        </button>
      )}
    </div>
  );
}

export default ButtonBuyNow;
